<app-modal [isOpen]="isOpen" title="Net Worth Trend" [showCancel]="false" doneLabel="Done" (done)="onDone()"
    (close)="onCancel()">
    <div class="net-worth-modal-content">
        <!-- Fund Header -->
        <div class="fund-header mb-4">
            <div class="fund-title-row">
                <h2 class="fund-name">{{ apiData.fundInfo.name }}</h2>
                <span class="trend-badge positive"><img *ngIf="isPositive"
                        class="investment-overview-widget__arrow-icon" src="assets/icons/up-trend.svg" alt="Arrow Up">
                    <img *ngIf="!isPositive" class="investment-overview-widget__arrow-icon"
                        src="assets/icons/up-trend-red.svg" alt="Arrow Up">{{ apiData.fundInfo.trend }}</span>
            </div>
        </div>

        <!-- Balance Card -->
        <div class="balance-card mb-4">
            <div class="balance-item opening">
                <div class="label">Opening Balance</div>
                <div class="value-row">
                    <span class="value">{{ apiData.fundInfo.openingBalance | number:'1.0-0' }}</span>
                    <span class="currency">{{ apiData.fundInfo.currency }}</span>
                </div>
            </div>
            <div class="divider"></div>
            <div class="balance-item current">
                <div class="label-row">
                    <span class="label">Current Balance</span>
                    <span class="change positive">{{ apiData.fundInfo.change }} <i
                            class="bi bi-arrow-up-short"></i></span>
                    <img src="assets/icons/arrow-down-thick.svg" alt="arrow-right" class="arrow-right-icon">
                </div>
                <div class="value-row">
                    <span class="value">{{ apiData.fundInfo.currentBalance |
                        currency:apiData.fundInfo.currency:'symbol':'1.2-2' }}</span>
                    <span class="currency">{{ apiData.fundInfo.currency }}</span>
                </div>
            </div>
        </div>

        <!-- Segmented Control -->
        <div class="segmented-control mb-4">
            <button type="button" class="segment-btn" [class.active]="activeTab === 'daily'"
                (click)="onTabChange('daily')">
                DAILY
            </button>
            <button type="button" class="segment-btn" [class.active]="activeTab === 'monthly'"
                (click)="onTabChange('monthly')">
                MONTHLY
            </button>
            <button type="button" class="segment-btn" [class.active]="activeTab === 'weekly'"
                (click)="onTabChange('weekly')">
                WEEKLY
            </button>
            <button type="button" class="segment-btn" [class.active]="activeTab === 'annually'"
                (click)="onTabChange('annually')">
                ANNUALLY
            </button>
        </div>

        <!-- Chart Placeholder -->
        <div class="chart-container">
            <!-- We can add a canvas here later if needed, for now just a placeholder to match the look -->
            <div class="placeholder-chart">
                <!-- <svg width="100%" height="150" viewBox="0 0 400 150" preserveAspectRatio="none">
                    <path d="M0,150 L50,120 L100,140 L150,100 L200,130 L250,80 L300,110 L350,90 L400,120" fill="none"
                        stroke="#26BC8F" stroke-width="2" />
                    <path
                        d="M0,150 L50,120 L100,140 L150,100 L200,130 L250,80 L300,110 L350,90 L400,120 L400,150 L0,150"
                        fill="url(#chartGradient)" opacity="0.1" />
                    <defs>
                        <linearGradient id="chartGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                            <stop offset="0%" style="stop-color:#26BC8F;stop-opacity:1" />
                            <stop offset="100%" style="stop-color:#26BC8F;stop-opacity:0" />
                        </linearGradient>
                    </defs>
                </svg> -->
                <canvas baseChart [data]="lineChartData" [options]="lineChartOptions" [type]="lineChartType">
                </canvas>
            </div>
        </div>
    </div>
</app-modal>